module.exports = __webpack_public_path__ + "static/img/s113.a63a8193.png";